import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'

import { getFeatured } from '@helpers/helper.developments'
import { RealEstateDataPageComponentData } from 'types'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import { Container } from 'react-bootstrap'
import { keys } from 'lodash'


const Summary_Devs_3 = (props: RealEstateDataPageComponentData) => {
  const { isDemo } = props
  const { title, button, darkMode, excludeTag, is_wide, global_data } = isDemo ? props : props
  const devCard = global_data.content?.cardsDevelopments?.type_id ?? '1'

  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(global_data.pageConfig.keys.tokko)

  const [developments, setDevelopments] = useState<any>(allDevelopmentsData)

  useEffect(() => {
    if (allDevelopmentsData) {
      const devs = allDevelopmentsData.filter(
        (dev) =>
          !dev.custom_tags.find((ctag) => ctag.name.toLowerCase() === excludeTag?.toLowerCase()),
      )
      setDevelopments(devs)
    }
  }, [allDevelopmentsData])

  const Card = require(`@components/cardsDevelopments/${devCard}`)?.default

  const WrapperContent = () => {
    if (is_wide) {
      return (
        <Container fluid>
          {getFeatured(developments!)?.map((development, i) => (
            <Card
              i={i}
              key={i}
              isItem={true}
              development={development}
              align={i % 2 === 0 ? 'left' : 'right'}
              global_data={global_data}
            />
          ))}
        </Container>
      )
    }
    return (
      <>
        {getFeatured(developments!)?.map((development, i) => (
          <Card
            i={i}
            key={i}
            isItem={true}
            development={development}
            align={i % 2 === 0 ? 'left' : 'right'}
            global_data={global_data}
          />
        ))}
      </>
    )
  }

  return (
    <section className={'desarrollos-home b p-y-config pb-0 ' + (darkMode ? 'dark' : '')}>
      <div className="container-fluid flex-column d-flex justify-content-center">
        <h2 className="text-center mb-lg-5 mb-5">{title}</h2>
      </div>
      {isLoading ? (
        <div className="d-flex w-100">
          {[1, 2, 3].map((i, index) => (
            <div
              key={index}
              className={
                'd-lg-block w-100 px-3 ms-2 me-2 ' + index + ' ' + (index !== 2 ? 'd-none' : '')
              }
            >
              <Card
                i={i}
                isItem={true}
                skeleton={true}
                global_data={global_data}
              />
            </div>
          ))}
        </div>
      ) : (
        WrapperContent()
      )}
      {button?.link && (
        <div className="footer-container d-flex justify-content-center">
          <Link
            to={button?.link}
            className="btn btn-white white border"
          >
            {button?.value}
          </Link>
        </div>
      )}
    </section>
  )
}

export default Summary_Devs_3
